import Modal from 'bootstrap/js/dist/modal';

const modalVisible = document.querySelector('.modal-visible-load');
if (modalVisible) {
  const modal = new Modal(modalVisible);
  modal.show();
}
